<template>
  <div class="path">
    <b-field>
      <b-input placeholder="Заголовок" v-model="investmentPath.title" 
        required @change="updateInvestmentPath(investmentPath)"
      ></b-input>
    </b-field>

    <b-field>
      <b-input placeholder="Текст" type="textarea" v-model="investmentPath.description" 
        @change="updateInvestmentPath(investmentPath)" required
      ></b-input>
    </b-field>

    <b-field>
      <b-input placeholder="Надпись на кнопке видео" v-model="investmentPath.button_title" 
        required @change="updateInvestmentPath(investmentPath)"
      ></b-input>
    </b-field>

    <b-field>
      <b-input placeholder="Ссылка на видео" v-model="investmentPath.button_link"
        required @change="updateInvestmentPath(investmentPath)"
      ></b-input>
    </b-field>

    <div class="button-wrapper" @click="deleteInvestmentPath(investmentPath.id)">
      <img src="/static/img/icons/delete.svg" class="delete-icon"/>
      Удалить путь
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'InvestmentPath',
    data () {
      return { }
    },
    props: {
      investmentPath: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteInvestmentPath', 'updateInvestmentPath'])
    }
  }
</script>

<style scoped>
.path {
  width: 100%;
  padding: 20px;
  margin: 10px auto;
  max-width: 900px;
  position: relative;
  background: #eeeeee;
}

.delete-icon {
  position: initial;
  width: 40px;
  margin: 0 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// InvestmentPath.vue?f5ad5768